import React, { useEffect } from "react";
import "../styles/AboutUs.css";

const AboutUs = () => {
    const sections = [
        {
            title: "The Bar",
            description:
                "Want to drink like a local? You're in the right place. We pour regional wine and sought-after brews from the communities we call home. Our cocktail program is stacked with new inventions and party-sized drinks for the table.",
            image: "/Chai-Espresso-Martini-1.jpg",
            reverse: false,
        },
        {
            title: "The Food",
            description:
                "If it's the kind of food you crave, chances are we've crafted our own version. We're inspired by Italian-style cooking and approachable North American faves that make it easy for everyone to find something they love.",
            image: "/Greek-Style-Lamb-Chops-featsq-1.jpg",
            reverse: true,
        },
        {
            title: "The Space",
            description:
                "Our space combines comfort and elegance to create unforgettable experiences. Whether you're here for a cozy dinner or a lively event, our venue is designed to leave a lasting impression.",
            image: "/enjoy-cafe-del-sol.jpg",
            reverse: false,
        },
    ];

    useEffect(() => {
        // Scroll animation for sections
        const aboutSections = document.querySelectorAll(".about-section");
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("visible");
                    }
                });
            },
            { threshold: 0.2 }
        );

        aboutSections.forEach((section) => observer.observe(section));
    }, []);

    return (
        <div className="about-us-page">
            <div className="hero-section">
                <h1 className="hero-title">About Us</h1>
                <p className="hero-description">
                    Discover what makes Sol Café & Lounge your perfect
                    destination for unforgettable moments.
                </p>
            </div>
            {sections.map((section, index) => (
                <div
                    key={index}
                    className={`about-section ${
                        section.reverse ? "reverse" : ""
                    }`}
                >
                    <div className="image-container">
                        <img src={section.image} alt={section.title} />
                    </div>
                    <div className="text-container">
                        <h2>{section.title}</h2>
                        <p>{section.description}</p>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default AboutUs;
